// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HDhr","col":"styles_col__2yuyY"};